export default __webpack_public_path__ + "static/media/ico-blue-white-info.074b3933.svg";